import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiftOffAngle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_132",
		"data-name": "Group 132",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_35",
			"data-name": "Rectangle 35",
			width: 72.551,
			height: 33.802,
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_131",
			"data-name": "Group 131",
			transform: "translate(20.353 2.517)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_279",
					"data-name": "Path 279",
					d: "M295.443,720.793a2.308,2.308,0,0,0,.141-1.98c-.138-.368-.3-.789-.479-1.238a22.913,22.913,0,0,1-1.612-5.107c-.014-1.14.242-4.04.7-7.957a1.259,1.259,0,0,0-.138-.726c.209-.134.434-.269.691-.4,1.163-.6,3.535-1.792,4.856-2.456a1.055,1.055,0,0,0,.47-1.417h0a1.056,1.056,0,0,0-1.418-.47c-1.326.666-3.707,1.865-4.874,2.466a9.432,9.432,0,0,0-2.542,1.856l-.119.006a3.331,3.331,0,0,1-1.131-1.658,4.331,4.331,0,0,1,.058-1.767c.011-.046.008-.092.015-.138.368-.113.827-.269,1.429-.475a30.529,30.529,0,0,0,5.79-3.422,1.055,1.055,0,1,0-1.252-1.7,28.027,28.027,0,0,1-5.222,3.124c-.783.267-1.24.412-1.5.49a2.136,2.136,0,0,0-1.267-.483,10.493,10.493,0,0,0-1.979.131,19.217,19.217,0,0,0-3.543.879,6.316,6.316,0,0,0-2.366.079,1.056,1.056,0,0,0-.808.57,6.568,6.568,0,0,0,.207,5.3c1.112,2.745,5.582,11.2,5.794,11.6.1.175,2.5,4.206,5.4,5.582a.918.918,0,0,0,.13.743,1.225,1.225,0,0,0,1.038.546H294.9a1.08,1.08,0,0,0,1.065-.806A1.051,1.051,0,0,0,295.443,720.793Zm-5.78-22.741a1.043,1.043,0,0,0-.176-.086A1.006,1.006,0,0,1,289.663,698.052Zm-2.473,16.82c-.046-.087-4.609-8.72-5.681-11.366a5.46,5.46,0,0,1-.422-3.058c.358-.035.675-.057.841-.057h0l.144.064a1.064,1.064,0,0,0,.842,0,15.833,15.833,0,0,1,3.466-.9,7.368,7.368,0,0,1,1.6-.094.024.024,0,0,1,.007.022h0a6.259,6.259,0,0,0-.062,2.664,5.768,5.768,0,0,0,2.484,3.316,1.058,1.058,0,0,0,.928.093c.2-.077.425-.149.635-.209-.271,2.394-.609,5.7-.591,7.145.015,1.3.771,3.333,1.757,5.852.172.438.332.849.467,1.209.056.148.008.193-.021.221-.19.179-.837.29-1.835-.147C289.806,718.777,287.783,715.877,287.19,714.872Z",
					transform: "translate(-269.285 -694.003)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_280",
					"data-name": "Path 280",
					d: "M288.242,744.506h-5.054a1.056,1.056,0,1,0,0,2.111h5.054a1.056,1.056,0,1,0,0-2.111Z",
					transform: "translate(-270.808 -717.849)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_281",
					"data-name": "Path 281",
					d: "M270.78,744.506h-3.167a1.056,1.056,0,1,0,0,2.111h3.167a1.056,1.056,0,1,0,0-2.111Z",
					transform: "translate(-263.454 -717.849)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_282",
					"data-name": "Path 282",
					d: "M268.769,708.608l-3.972.151a1.056,1.056,0,0,0,.04,2.111h.041l1.053-.04a15.8,15.8,0,0,0-2.388,12.918l-1.189-.861a1.056,1.056,0,1,0-1.238,1.71l3.22,2.331a1.056,1.056,0,0,0,1.474-.236l2.331-3.22a1.056,1.056,0,1,0-1.71-1.238l-.811,1.12a13.649,13.649,0,0,1,2.215-11.542l.071,1.865a1.056,1.056,0,0,0,1.055,1.015H269a1.057,1.057,0,0,0,1.015-1.1l-.15-3.973A1.036,1.036,0,0,0,268.769,708.608Z",
					transform: "translate(-260.677 -700.898)",
					fill: "#101820"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgLiftOffAngle);
export { ForwardRef as ReactComponent };
